<footer>
  <div class="content-wrapper">
      <div class="float-left">
          <p>&copy; {{currentYear}} {{'ChevronCorporationAllrightsreserved' | translate}}</p>
      </div>
  </div>
</footer>
